import { Grid, Typography } from '@mui/material';
import { FC } from 'react';
import { DocumentTitle } from '../../../../components/DocumentTitle';
import { InvitePatientWidget, PatientCountWidget } from '../../../patient';
import { LastScansWidget, ScanCountWidget } from '../../../scan';
import { LastScansContainer } from './styles';
import { SignupRequestsTable } from '../../../signupRequests/components';
import { FDADashboardTable } from '../../../functionalDynamicAssessment/components/FDADashboardTable';
import { useAccountContext } from '../../../account/containers';

export const DashboardScreen: FC = () => {
  const { user } = useAccountContext();
  return (
    <div>
      <div>
        <DocumentTitle title='Dashboard' />
        <Typography variant='h2' style={{ fontWeight: 700 }}>
          Dashboard
        </Typography>
      </div>
      <Grid container spacing={2} alignItems='stretch' mt={0}>
        <Grid item xs={5}>
          <ScanCountWidget />
        </Grid>
        <Grid item xs={3.5}>
          <PatientCountWidget />
        </Grid>
        <Grid item xs={3.5}>
          <InvitePatientWidget />
        </Grid>
        <Grid item xs={12}>
          <SignupRequestsTable />
        </Grid>
        <Grid item xs={12}>
          <LastScansContainer>
            <LastScansWidget />
          </LastScansContainer>
        </Grid>
        {user.functional_analysis_enabled && (
          <Grid item xs={12}>
            <FDADashboardTable patientView={false} />
          </Grid>
        )}
      </Grid>
    </div>
  );
};
